import { lazy, Suspense } from "react";
import { useLazyVisible } from "@/common/hooks/useLazyVisible";
import { PageLoader } from "@/components/PageLoader";
import { Application } from "@/pages/Home/ui/Application";
import { Banner } from "@/pages/Home/ui/Banner";
import { FAQ } from "@/pages/Home/ui/FAQ";
import { HowItWorks } from "@/pages/Home/ui/HowItWorks";

const Advantages = lazy(
  () => import(/* webpackChunkName: "home-advantages" */ "./ui/Advantages"),
);

export const HomePage = () => {
  const { ref: advantagesRef, isVisible: isVisibleAdvantages } =
    useLazyVisible<HTMLDivElement>();

  return (
    <PageLoader>
      <Banner />
      <HowItWorks />
      <div ref={advantagesRef}>
        {isVisibleAdvantages && (
          <Suspense fallback={null}>
            <Advantages />
          </Suspense>
        )}
      </div>
      <Application />
      <FAQ />
    </PageLoader>
  );
};
